import React from 'react';
import ReactDOM from 'react-dom';
import ExportDataGrid from './ExportDataGrid';
import HtmlArgUtil from '../utils/HtmlArgUtil';
import FormItemUtil from '../utils/FormItemUtil';
import CommandResolver from '../utils/CommandResolver';
import GOTUtil from '../utils/GOTUtil';
import GOT from '../utils/GOT';
import TableExport from'./jqueryTableExport';
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
import ListDataGrid from './ListDataGrid';
import CommandTask from '../forms/sys/remote/CommandTask';
import Cmd from '../forms/sys/remote/Cmd';
import Copy from 'copy-to-clipboard';
import Fade from'../utils/Fade';
import CommonUtil from '../utils/CommonUtil';
import Warn from '../utils/Warn';
require('./customMenu.css');

export default class CustomMenu extends React.Component{
	constructor(props, context) {
    	super(props, context);

  		this.state = {};
		this.state.title='自定义常用菜单';
		this.state.warnTitle = "";		  
  		
  		this.userId = window.parent.window.userInfos.userId?window.parent.window.userInfos.userId:window.userInfos.userId;

  		this.state.translateX=0,
  		this.state.translateY=0,
  		this.moving = false;
  		this.lastX = null;
  		this.lastY = null;
  		//window.onmouseup = e => this.onMouseUp(e);
  		//window.onmousemove = e => this.onMouseMove(e);
  		if(this.props.menuCustomObject)
  			this.temp = Object.assign({customItems:{},groups:{}},this.props.menuCustomObject);
  		else
  			this.temp = {customItems:{},groups:{}};
  	}
  	
  	componentDidMount=()=>{
  		/*var setting = {
			data: 
			{
				key: {
					title:"label",
					children:"items",
					name:"label"
				}
			},
			callback:
			{
				onClick: this.onItemClick.bind(this),
				onDblClick: this.onItemDblClick.bind(this)
			}
		};
		window.got.MainMenu.label="主菜单";
		$.fn.zTree.init($(this.mainMenuTreeNode), setting, window.got.MainMenu);*/
		$(this.slimScrollDiv).slimScroll({height:'auto',color: "rgba(0,0,0,0.2)",size: "3px"});
		$(this.customMenuDiv).draggable({
			handle: ".modal-header"// 只能点击头部拖动
			
		}); //为模态对话框添加拖拽

		if(this.customMenuDiv.scrollHeight>this.customMenuDiv.clientHeight||this.customMenuDiv.offsetHeight>this.customMenuDiv.clientHeight)
		{ 
			$(this.customMenuDiv).height(this.customMenuDiv.scrollHeight+25);
		} 
		
		/*let nowHeight = $(this.customMenuDiv).outerHeight();
		if(nowHeight<610)
		{
			$(this.customMenuDiv).height(610);
		}*/
		
	}

	onItemClick(event, treeId, treeNode, clickFlag){}
	onItemDblClick(event, treeId, treeNode, clickFlag){}

	/** 拖拉 */
	onMouseDown(e) {
	  e.stopPropagation();
	  this.moving = true;
	}

	onMouseUp() {
	  this.moving = false;
	  this.lastX = null;
	  this.lastY = null;
	}

	onMouseMove(e) {
	  this.moving && this.onMove(e);
	}

	onMove(e) {
	
	  if (this.lastX && this.lastY) {	
		let dx = e.clientX - this.lastX;
		let dy = e.clientY - this.lastY;
		console.log("dx:"+dx +";dy:"+dy);
	    this.setState({
	      translateX: this.state.translateX + dx,
	      translateY: this.state.translateY + dy
		})
	  }
	  this.lastX = e.clientX;
	  this.lastY = e.clientY;

	  console.log(this.state.translateX,this.state.translateY);
	}
	
  	

  	

	hideExportTable=()=>{
		$("#exportModal").empty();

	}

	menuItemClickSelect(event)
	{
		var target = event.target;
		$("#customMenuModalContainer .customMenuTree div.selected").removeClass("selected");
		$(target).addClass("selected");
	}

	getLabelName(item){
		var label=GOTUtil.getPropertyValue(item,"Label");
      	if(label==""|!label){
      		label=item.name;
      	}
      	return label;
	}

	addMostHandler(e)
	{
		let parentA	= $(e.target).parent().parent();
		let parentLi = parentA.parent();

		parentLi.addClass("usual");
		let key = parentA.attr("data-menuitemid") + "." + parentA.attr("data-idinmenu");
		this.temp.customItems[key] = {groupId:""};
	}

	removeMostHandler(e)
	{
		let parentA	= $(e.target).parent().parent();
		let parentLi = parentA.parent();

		parentLi.removeClass("usual");
		let key = parentA.attr("data-menuitemid") + "." + parentA.attr("data-idinmenu");
		delete this.temp.customItems[key];
		parentA.find(".most-group-info").remove();
	}

	renderSub(items,moudleId,parent)
	{	
		var content=[];
		
		if(items)
		{	
			for(var i=0;i<items.length;i++)
			{
				var item = items[i];
				//item.pId = parent.id;
      			if(item.qname)
      			{
      				if(item.qname=="MenuItem")
      				{	
      					
						var isShow=false;   
      					
      					var visible=item.Properties.Visible.V;
      					if(visible!='false'){
							  if(window.userInfos.isAdmin)
							  {
								isShow = true;
							  }
							  else
							  {
	      						var thisAu=moudleId+'.'+item.idInMenu;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							
									if(authorityArr.del || authorityArr.query)
									{
										isShow = true;
									}
				      			}
				      		}
      					}
      					var label=this.getLabelName(item);
      					
	      				if(isShow)
	      				{
							
							var _clsName = "iconfont icon-default text-blue";
							var iconPro = GOTUtil.getPropertyValue(item,"Icon");
							if(iconPro)_clsName = iconPro;
							let treeviewClassName = "treeview menuItem";
							let key = item.id+"."+item.idInMenu;
							let _groupId = "";
							let _groupItem = null;
							if(this.temp.customItems.hasOwnProperty(key))
							{
								treeviewClassName += " usual";
								_groupId = this.temp.customItems[key].groupId;
								if(_groupId && this.temp.groups.hasOwnProperty(_groupId))
								{
									let _groupItemData = this.temp.groups[_groupId];
									_groupItem = <div data-groupid={_groupId} className="most-group-info text-green" style={{backgroundColor:"aquamarine",marginRight:"20px"}}>{_groupItemData.name}</div>; 
								}
							}
								
							let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
	      					content.push(
	      						<li className={treeviewClassName} key={'menuItem-li'+i}>
									<a title={label} style={{cursor:"pointer",display:'flex',alignItems:'center',paddingTop:'1px',paddingBottom:'1px'}} onClick={this.menuItemClickSelect} data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-groupId={_groupId} data-idInMenu={item.idInMenu}>
										<i className={_clsName} style={{flexShrink:0,marginRight:'4px',marginTop:'2px',fontSize:'14px'}}></i> 
										<div>{label}</div>
										<div className="treeview-menuItem-info" style={{flexGrow:1,alignItems:'center',justifyContent:'flex-end',display:'flex',marginRight:'25px'}}>
											{_groupItem}
											<div className="most text-green" style={{backgroundColor:"aquamarine"}}>常用</div>
											<i title="设为常用" className="fa fa-check text-green" style={{marginBottom:'3px'}} onClick={this.addMostHandler.bind(this)}></i>
											<i title="取消常用" className="fa fa-close text-red" style={{marginBottom:'3px'}} onClick={this.removeMostHandler.bind(this)}></i>
										</div>
	      							</a>
	      						</li>
	      					);
	      				}
      					
      				}else if(item.qname=="MenuSub")
      				{	
      					
      					var isShow=false; 
      					var visible=item.Properties.Visible.V;
      					if(visible=='true'){
      						if(window.userInfos.isAdmin){
	      						isShow=true;
	      					} else{
	      						var thisAu=moudleId+'.'+item.id;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	      								isShow=false;
	      							}else{
	      								isShow=true;
	      							}
	      						}
	      					}
      					}
      					
      					var label=this.getLabelName(item);
						  if(isShow)
						  {
							
							var _clsName = "fa fa-bars text-blue";
							var iconPro = GOTUtil.getPropertyValue(item,"Icon");
							if(iconPro)_clsName = iconPro;
	  						content.push(
		      						<li className="treeview menuSub" key={'menuSub-li'+i}>
										<a style={{cursor:"pointer"}}>
										<i className={_clsName}></i> 
										<span>{label}</span>
										<span className="pull-right-container">
										<i className="fa fa-angle-left pull-right"></i>
										</span>
										</a>
										<ul className="treeview-menu">
											{this.renderSub(item.items,moudleId,item)}
		      							</ul>
		      						</li>
	  							);
      						}

      				}
      			}
      			else
      			{	
      				var isShow=false; 
      				var visible=item.Properties.Visible.V;
      				if(visible=='true'){
      					if(window.userInfos.isAdmin){
		      				isShow=true;
		      			}else{
		      				moudleId=item.id; 
			      			var authorityArr=window.xmlType0SCache[moudleId];
			      			if(authorityArr){
			      				if(authorityArr.del){
			      					isShow=true;
			      				}else{
			      					isShow=false;
			      				}
			      			}
		      			}
      				}
      				
      				var label=this.getLabelName(item);
      				if(isShow){
						var _clsName = "fa fa-th-list text-blue";
						var iconPro = GOTUtil.getPropertyValue(item,"Icon");
						if(iconPro)_clsName = iconPro;
      					content.push(
	      					<li className="treeview" key={'treeview'+i}>
		      					<a style={{cursor:"pointer"}}>
			      					<i className={_clsName}></i> 
			      					<span>{label}</span>
			      					<span className="pull-right-container">
			      					<i className="fa fa-angle-left pull-right"></i>
			      					</span>
		      					</a>
		      					<ul className="treeview-menu">
		      						{this.renderSub(item.items,moudleId,item)}
		      					</ul>
	      					</li>
      					);
      				}

      			}
			}
		}
		return content;
	}

	hideCustomMenuGroupSet(e)
	{
		$(this.customMenuGroupSet).hide();
	}

	saveCustomMenuGroup(e)
	{
		$(this.customMenuGroupSet).hide();
		let uuid = CommonUtil.guid();
		let groupName = $(this.inputGroupName).val();
		this.temp.groups[uuid] = {name:groupName};

		
		let closeBtn = $('<i class="fa fa-close text-red" style="position: absolute;right: 1px;top:0px;cursor:pointer"></i>').attr("data-groupid",uuid).attr("data-groupname",groupName).click(this.deleteMostGroup.bind(this));
		$(this.mostGroupContainer).prepend(
			$('<div class="most-group text-green" style="background-color:aquamarine;font-size:17px;position: relative;padding-left: 10px;padding-right: 10px;">'+groupName+'</div>').append(closeBtn)
		);
	}

	addMostGroup()
	{
		$(this.customMenuGroupSet).show();
	}

	getGroups()
	{
		/*
		<div class="most-group text-green" style="font-size: 17px;background-color: aquamarine;position: relative;padding-left: 10px;padding-right: 10px;"><i class="fa fa-close text-red" style="
    		position: absolute;
    		right: 1px;
		"></i>测试分组</div>
		*/
		let groups = [];
		for(let key in this.temp.groups)
		{
			let group = this.temp.groups[key];
			let label = group.name;
			groups.push(<div className="most-group text-green" style={{backgroundColor:'aquamarine',fontSize:'17px',position:'relative',paddingLeft:'10px',paddingRight:'10px'}}>
							{label}
							<i data-groupid={key} data-groupname={label} className="fa fa-close text-red" style={{position:'absolute',right:'1px',top:'0px',cursor:'pointer'}} onClick={this.deleteMostGroup.bind(this)}></i>
						</div>
						);
		}
		return groups;
	}

	deleteMostGroup(e)
	{

		let groupKey = $(e.target).attr("data-groupid");
		if(this.temp.groups.hasOwnProperty(groupKey))
		{
			delete this.temp.groups[groupKey];
		}
		for(let key in this.temp.customItems)
		{
			let customItem = this.temp.customItems[key];
			if(customItem.groupId == groupKey)
				customItem.groupId = "";
		}
		$(e.target).parent().remove();

		$("#customMenuModalContainer .most-group-info").each(
			function(item)
			{
				if($(this).attr("data-groupid") == groupKey)
					$(this).remove();
			}
		);
	}

	addSettingToGroup(e)
	{
		let selectedMenuItems = $("#customMenuModalContainer .customMenuTree .usual div.selected");
		if(selectedMenuItems.length<1)
		{
			Warn.show({text:"请选中一个常用菜单项"});
			return;
		}
		let parentA = selectedMenuItems.parent();
		let _currentAddingToGroupKey = (parentA.prop("data-menuitemid") || parentA.attr("data-menuitemid")) + "." + (parentA.prop("data-idinmenu") || parentA.attr("data-idinmenu"));
		this.currentAddingToGroupKey = _currentAddingToGroupKey;
		this.currentAddingToGroupA = parentA;

		$(this.groupSelectUL).empty();
		for(let key in this.temp.groups)
		{
			let item = this.temp.groups[key];
			let $li = $("<li style='cursor:pointer;font-size:14px'>").click(this.groupClickHandler.bind(this)).html(item.name).attr("data-groupid",key).attr("data-groupname",item.name);
			$(this.groupSelectUL).append($li);
		}
		$(this.customMenuGroupAddContainer).show();
		
		//<li style={{cursor:'pointer'}} onClick={this.groupClickHandler.bind(this)}>111</li>
		

	}

	saveSetting(e)
	{
		//localStorage.setItem("tempTest",JSON.stringify(this.temp));
		var ugse = window.userSettingEntryOrig;
		ugse.menuCustomObject = JSON.stringify(this.temp);

		for (var k in ugse) {
			if(typeof(ugse[k]) != "string")
				ugse[k] = ugse[k].toString();
		}

		var command = Command.createService( "gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
		
		command.appendArg(window.userInfos.userId); //ClientSession.getClientSessionInstance().userId
		command.appendArg(ugse,"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");


		var saveResultHandler = function(data)
		{
			window.userSettingEntryOrig = ugse;
			if(Boolean(data.result))
			{
				if(Boolean(data.result))
				{
					var options={
						state:'success',
						text: "已成功保存您的偏好设置"
					}
					Fade.show(options);
				}
				else
				{
					var options = {
					  state: 'error',
					  text: "保存失败"
					}
					Fade.show(options);
				}
			}
		}

		var remoteArg = {
			command: command,
			resultFunction: saveResultHandler,
			sync: false
		}
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	hideCustomMenuGroupAdd(e)
	{
		$(this.customMenuGroupAddContainer).hide();
	}

	saveCustomMenuAdd(e)
	{
		let lis = $(this.groupSelectUL).find("li.selected");
		if(lis.length<1)
		{
			Warn.show({text:"请选择一个分组"});
			return;
		}
		if(!this.currentAddingToGroupKey || !this.temp.customItems.hasOwnProperty(this.currentAddingToGroupKey))
			return;
		let _groupId = $(lis[0]).attr("data-groupid");
		let _groupName = $(lis[0]).attr("data-groupname");
		this.temp.customItems[this.currentAddingToGroupKey].groupId = _groupId;
		let menuItemInfo = this.currentAddingToGroupA.find(".treeview-menuItem-info");
		menuItemInfo.find(".most-group-info").remove();
		menuItemInfo.prepend($("<div class='most-group-info text-green' style='background-color:aquamarine;margin-right:20px' data-groupid='"+_groupId+"'>"+_groupName+"</div>"));
		this.hideCustomMenuGroupAdd();
	}

	groupClickHandler(e)
	{
		$(this.groupSelectUL).find("li").removeClass("selected");
		$(e.target).addClass("selected");
	}

  	render(){
  		
  		
  		var _columns = [];
  		
  		const title=this.state.title;

  		let mainMenu = window.got.MainMenu;
		var moudleId;
		const mainContent=this.renderSub(mainMenu.items,moudleId,mainMenu);
  		/*
  		<ul id='customMenuTree' ref={node=>this.mainMenuTreeNode=node} style={{height:'415px',width:'200px'}}>
										
									</ul> 
  		*/
  		let customMenuItemGroups = this.getGroups();
  		return(
	  		<div>
	  			<div className='modal' id="customMenuModalContainer" style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}} key="mainModal">
		      		<div ref={node=>this.customMenuDiv = node} style={{height:'80%',display:'flex',flexDirection:'column',alignItems:'stretch',justifyContent:'center',overflow:'auto',background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
		        		<div className='modal-header'>
		          			<div className="modal-close" onClick={this.hideExportTable}></div>
		          			<h5 className='modal-title'>{title}</h5>
		        		</div>
						   <div ref={node=>this.slimScrollContainer=node} className='modal-body' style={{padding:'0px 15px',display:'flex',flexDirection:'column',alignItems:'stretch',flexGrow:1}}>

						   <div ref={node=>this.mostGroupContainer=node} style={{display:'flex',flexDirection:'row',flexWrap:'wrap',marginTop:'10px',marginBottom:'10px',alignItems:'center',maxWidth:'404px'}}>
						   		{customMenuItemGroups}
						   		<div title="点击添加分组" style={{cursor:'pointer',backgroundImage: 'url("./images/add_1.png")',width:'20px',height:'20px',backgroundSize:'100% 100%',marginBottom:'5px'}} onClick={this.addMostGroup.bind(this)}></div>
						   </div>

						   <div className='skin-blue-light' ref={node=>this.slimScrollDiv=node} style={{backgroundColor:'#f4f4f5',overflow:'hidden',width:'auto',marginBottom:'0',WebkitTouchCallout:'none',WebkitUserSelect:'none',MozUserSelect:'none',msUserSelect:'none',user
					:'none'}}>
								
			            		<div className='box-body sidebar' style={{marginTop:'5px',padding:'0',marginRight:'14px'}}>
									<ul className="customMenuTree sidebar-menu" style={{overflowX:'auto',width:'400px'}}>
        								{mainContent}
        							</ul>
								</div>
							</div>

		       				
							
		       			</div>
		        		<div className='modal-footer' style={{padding:'10px 15px 8px',borderTopColor:'rgba(0,0,0,0.10)',marginTop:'10px',borderTop:'1px solid rgba(0,0,0,0.10)'}}>
		        				
		            		<button type='button' className='btn btn-info' onClick={this.addSettingToGroup.bind(this)} style={{height:'28px',width:'115px'}}><i style={{marginRight:'3px'}} className="fa fa-plus" aria-hidden="true"></i>添加到分组</button>
			        		<button type='button' className='btn btn-info' onClick={this.saveSetting.bind(this)} style={{height:'28px',width:'88px'}}><i style={{marginRight:'3px'}} className="fa fa-download" aria-hidden="true"></i>保存</button>
			    
		        			
		        		</div>


		        		<div className="modal" ref={node=>this.customMenuGroupSet=node} key="saveModal" style={{zIndex: '2000'}}>
						    <div className="modal-dialog" style={{marginTop:'100px',width:'640px'}}>
					            <div className="modal-content" style={{
									    background:'#FFFFFF',
										border: '1px solid #9B9B9B',
										boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
										borderRadius: '2px'
								}}>
					              <div className="modal-header">
					               
									<div className="modal-close" onClick={this.hideCustomMenuGroupSet.bind(this)}></div>
					                <h4 className="modal-title" style={{marginTop:'0',marginBottom:'0'}}>设置分组名称</h4>
					              </div>
					              <div className="modal-body" style={{display:'flex',flexDirection:'column',padding:'40px 10px'}} >
									<div style={{flexGrow:0,textAlign:'center'}} >
								  		<div style={{display:'flex',flexDirection:'row',paddingLeft:'35px'}}>
										  <div style={{textAlign:'right'}} >
											<label style={{paddingTop:'8px',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',fontWeight:'normal'}} >分组名称：</label> 
								  		  </div>
								  		  <div style={{textAlign:'left',flexGrow:1,marginRight:'10px'}}>
											<input type="text" spellcheck="false" className="form-control" ref={node=>this.inputGroupName=node}/>
										  </div>
										</div>
									</div>
					              </div>
					              <div className="modal-footer" style={{padding:'10px 15px'}}>
					                <button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} data-dismiss="modal" onClick={this.hideCustomMenuGroupSet.bind(this)}>取消</button>
					                <button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}}  onClick={this.saveCustomMenuGroup.bind(this)}>确定</button>
					              </div>
					            </div>
					        </div>
					  	</div>

					  	<div className="modal" ref={node=>this.customMenuGroupAddContainer=node} key="addModal" style={{zIndex: '2000'}}>
					  		<div className="modal-dialog" style={{marginTop:'100px',width:'370px'}}>
					            <div className="modal-content" style={{
									    background:'#FFFFFF',
										border: '1px solid #9B9B9B',
										boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
										borderRadius: '2px'
								}}>
					              <div className="modal-header">
					               
									<div className="modal-close" onClick={this.hideCustomMenuGroupAdd.bind(this)}></div>
					                <h4 className="modal-title" style={{marginTop:'0',marginBottom:'0'}}>选择分组</h4>
					              </div>
					              <div className="modal-body" style={{display:'flex',flexDirection:'column',padding:'20px 10px'}} >
									<ul className="customMenuGroupSelect" ref={node=>this.groupSelectUL=node}>
										
									</ul>
					              </div>
					              <div className="modal-footer" style={{padding:'10px 15px'}}>
					                <button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} data-dismiss="modal" onClick={this.hideCustomMenuGroupAdd.bind(this)}>取消</button>
					                <button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}}  onClick={this.saveCustomMenuAdd.bind(this)}>确定</button>
					              </div>
					            </div>
					        </div>
					  	</div>

		      		</div>
			   	</div>
			</div>
  		)
  	}
}


// WEBPACK FOOTER //
// ./src/menuCustom/CustomMenu.js